import { Box } from '@ovComponents/1-primative/box/box';
import { Typography } from '@ovComponents/1-primative/typography/typography';
import { UserContext } from '@providers/userContextProvider';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { HomePageWidget } from '../settings/homePageConfigurations/components/homePageWidget';

export const HomePage = () => {
  const { t } = useTranslation(['homePageConfiguration']);
  const { userContext } = useContext(UserContext);

  // Render the configured home page widgets (view-only)
  return (
    <Box>
      <Typography
        data-testid='client-name-title'
        sx={{ overflow: 'hidden', textOverflow: 'ellipsis', mb: 3 }}
        variant='displayLargeVariant'
      >
        {`${t('welcome')}, ${userContext.firstName}`}
      </Typography>

      {userContext.role?.homePageConfiguration.widgets.map(
        (widget: any, i: number) => (
          <Box key={widget.id || `widget-${i}`}>
            <HomePageWidget
              type={widget.type}
              i={i}
              viewOnly={true}
              options={widget.options || {}}
            />
          </Box>
        ),
      )}
    </Box>
  );
};
